import { useContext } from "react";
import { AppLoaderContext } from "../index";

const useAppLoader = () => useContext(AppLoaderContext);

export default useAppLoader;
